import React from "react"

import { extractFields } from "../../../../../../utils/form/extractFields"
import { checkRequireLabel } from "../../../../../../utils/form/checkRequireLabel"
import { useTranslations } from "@dfb/gatsby-dfb-theme/src/hooks/useTranslations"

import MDefaultform from "../m_defaultForm"
import DfbInput from "@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_input"
import DfbHeadline from "@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_headline"
import DfbParagraph from "@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_paragraph"
import DfbSelect from "@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_select"
import DfbCheckbox from "@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_checkbox"
import DfbInputTextarea from "@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_input_textarea"

const MPressApplication = ({ data }) => {
  const t = useTranslations()
  const formType = data.form_definition[0].identifier
  const fields = extractFields(data.form_definition[0].form_field)

  const selectMemberof = {
    identifier: fields.memberof.identifier,
    label: fields.memberof.label,
    required: fields.memberof.required,
    values: [
      {
        id: 0,
        name: "VDS",
      },
      {
        id: 1,
        name: "AIPS",
      },
      {
        id: 2,
        name: "DJV",
      },
    ],
  }

  const selectFunction = {
    identifier: fields.function.identifier,
    label: fields.function.label,
    required: fields.function.required,
    values: [
      {
        id: 0,
        name: "Redakteur",
      },
      {
        id: 1,
        name: "Fotograf",
      },
      {
        id: 2,
        name: "TV- oder Hörfunk-Redakteur ",
      },
      {
        id: 3,
        name: "Kameramann",
      },
      {
        id: 4,
        name: "Techniker",
      },
      {
        id: 5,
        name: "Sonstige",
      },
    ],
  }

  const selectMedia = {
    identifier: fields.categoryofmedia.identifier,
    label: fields.categoryofmedia.label,
    required: fields.categoryofmedia.required,
    values: [
      {
        id: 0,
        name: "Agentur",
      },
      {
        id: 1,
        name: "Zeitung",
      },
      {
        id: 2,
        name: "Zeitschriften",
      },
      {
        id: 3,
        name: "Internet",
      },
      {
        id: 4,
        name: "Fernsehen",
      },
      {
        id: 5,
        name: "Hörfunk",
      },
      {
        id: 6,
        name: "Freelance",
      },
      {
        id: 7,
        name: "Sonstige",
      },
    ],
  }

  const selectCountry = {
    identifier: fields.country.identifier,
    label: fields.country.label,
    required: fields.country.required,
    values: [
      { name: "Deutschland", id: 1 },
      { name: "Österreich", id: 2 },
      { name: "Schweiz", id: 3 },
      { name: "Afghanistan", id: 4 },
      { name: "Albanien", id: 5 },
      { name: "Algerien", id: 6 },
      { name: "Amer.Jungferni.", id: 7 },
      { name: "Andorra", id: 8 },
      { name: "Angola", id: 9 },
      { name: "Anguilla", id: 10 },
      { name: "Antarktis", id: 11 },
      { name: "Antigua/Barbuda", id: 12 },
      { name: "Argentinien", id: 13 },
      { name: "Armenien", id: 14 },
      { name: "Aruba", id: 15 },
      { name: "Aserbaidschan", id: 16 },
      { name: "Australien", id: 17 },
      { name: "Bahamas", id: 18 },
      { name: "Bahrain", id: 19 },
      { name: "Bangladessch", id: 20 },
      { name: "Barbados", id: 21 },
      { name: "Belarus", id: 22 },
      { name: "Belgien", id: 23 },
      { name: "Belize", id: 24 },
      { name: "Benin", id: 25 },
      { name: "Bermuda", id: 26 },
      { name: "Bhutan", id: 27 },
      { name: "Bolivien", id: 28 },
      { name: "Bonaire Saba", id: 29 },
      { name: "Bosnien-Herz.", id: 30 },
      { name: "Botsuana", id: 31 },
      { name: "Bouvet Inseln", id: 32 },
      { name: "Brasilien", id: 33 },
      { name: "Brit.Geb.Ind.Oz", id: 34 },
      { name: "Brit.Jungferni.", id: 35 },
      { name: "Brunei Drussal.", id: 36 },
      { name: "Bulgarien", id: 37 },
      { name: "Burkina-Faso", id: 38 },
      { name: "Burundi", id: 39 },
      { name: "Chile", id: 40 },
      { name: "China", id: 41 },
      { name: "Cookinseln", id: 42 },
      { name: "Costa Rica", id: 43 },
      { name: "Curaçao", id: 44 },
      { name: "Dominica", id: 45 },
      { name: "Dominik.Rep.", id: 46 },
      { name: "Dschibuti", id: 47 },
      { name: "Dänemark", id: 48 },
      { name: "Ecuador", id: 49 },
      { name: "El Salvador", id: 50 },
      { name: "Elfenbeiküste", id: 51 },
      { name: "Eritrea", id: 52 },
      { name: "Estland", id: 53 },
      { name: "Falklandinseln", id: 54 },
      { name: "Fidschi", id: 55 },
      { name: "Finnland", id: 56 },
      { name: "Frankreich", id: 57 },
      { name: "FranzPolynesien", id: 58 },
      { name: "Französ.Guayana", id: 59 },
      { name: "French S.Territ", id: 60 },
      { name: "Färöer", id: 61 },
      { name: "Gabun", id: 62 },
      { name: "Gambia", id: 63 },
      { name: "Georgien", id: 64 },
      { name: "Ghana", id: 65 },
      { name: "Gibraltar", id: 66 },
      { name: "Gournsey", id: 67 },
      { name: "Grenada", id: 68 },
      { name: "Griechenland", id: 69 },
      { name: "Grönland", id: 70 },
      { name: "Guadeloupe", id: 71 },
      { name: "Guam", id: 72 },
      { name: "Guatemala", id: 73 },
      { name: "Guinea", id: 74 },
      { name: "Guinea-Bissau", id: 75 },
      { name: "Guyana", id: 76 },
      { name: "Haiti", id: 77 },
      { name: "Heard/McDon.Ins", id: 78 },
      { name: "Honduras", id: 79 },
      { name: "Hongkong", id: 80 },
      { name: "Indien", id: 81 },
      { name: "Indonesien", id: 82 },
      { name: "Irak", id: 83 },
      { name: "Iran", id: 84 },
      { name: "Irland", id: 85 },
      { name: "Island", id: 86 },
      { name: "Israel", id: 87 },
      { name: "Italien", id: 88 },
      { name: "Jamaika", id: 89 },
      { name: "Japan", id: 90 },
      { name: "Jemen", id: 91 },
      { name: "Jersey", id: 92 },
      { name: "Jordanien", id: 93 },
      { name: "Kaimaninseln", id: 94 },
      { name: "Kambodscha", id: 95 },
      { name: "Kamerun", id: 96 },
      { name: "Kanada", id: 97 },
      { name: "Kap Verde", id: 98 },
      { name: "Kasachstan", id: 99 },
      { name: "Katar", id: 100 },
      { name: "Kenia", id: 101 },
      { name: "Kirgisistan", id: 102 },
      { name: "Kiribati", id: 103 },
      { name: "Kokosinseln", id: 104 },
      { name: "Kolumbien", id: 105 },
      { name: "Komoren", id: 106 },
      { name: "Kongo", id: 107 },
      { name: "Kroatien", id: 108 },
      { name: "Kuba", id: 109 },
      { name: "Kuwait", id: 110 },
      { name: "Laos", id: 111 },
      { name: "Libanon", id: 112 },
      { name: "Liberia", id: 113 },
      { name: "Libyen", id: 114 },
      { name: "Litauen", id: 115 },
      { name: "Macau", id: 116 },
      { name: "Madagaskar", id: 117 },
      { name: "Malawi", id: 118 },
      { name: "Malaysia", id: 119 },
      { name: "Malediven", id: 120 },
      { name: "Mali", id: 121 },
      { name: "Malta", id: 122 },
      { name: "Man Insel", id: 123 },
      { name: "Marokko", id: 124 },
      { name: "Marshall-Insel", id: 125 },
      { name: "Martinique", id: 126 },
      { name: "Mauretanien", id: 127 },
      { name: "Mauritius", id: 128 },
      { name: "Mayotte", id: 129 },
      { name: "Mazedonien", id: 130 },
      { name: "Mexiko", id: 131 },
      { name: "Mikronesien", id: 132 },
      { name: "Minor Outl.Ins.", id: 133 },
      { name: "Moldau", id: 134 },
      { name: "Monaco", id: 135 },
      { name: "Mongolei", id: 136 },
      { name: "Montserrat", id: 137 },
      { name: "Mosambik", id: 138 },
      { name: "Myanmar", id: 139 },
      { name: "Namibia", id: 140 },
      { name: "Nauru", id: 141 },
      { name: "Neapel", id: 142 },
      { name: "Neukaledonien", id: 143 },
      { name: "Neuseeland", id: 144 },
      { name: "Nicaragua", id: 145 },
      { name: "Niederlande", id: 146 },
      { name: "Niger", id: 147 },
      { name: "Nigeria", id: 148 },
      { name: "Niue-Inseln", id: 149 },
      { name: "Nordkorea", id: 150 },
      { name: "Norfolkinseln", id: 151 },
      { name: "Norwegen", id: 152 },
      { name: "Nördl. Marianen", id: 153 },
      { name: "Oman", id: 154 },
      { name: "Ost Timor", id: 155 },
      { name: "Osttimor", id: 156 },
      { name: "Pakistan", id: 157 },
      { name: "Palau", id: 158 },
      { name: "Palästina", id: 159 },
      { name: "Panama", id: 160 },
      { name: "Papua-Neuguinea", id: 161 },
      { name: "Paraguay", id: 162 },
      { name: "Peru", id: 163 },
      { name: "Philippinen", id: 164 },
      { name: "Pitcairn Inseln", id: 165 },
      { name: "Polen", id: 166 },
      { name: "Portugal", id: 167 },
      { name: "Puerto Rico", id: 168 },
      { name: "Republik Kongo", id: 169 },
      { name: "Reunion", id: 170 },
      { name: "Ruanda", id: 171 },
      { name: "Rumänien", id: 172 },
      { name: "Russische Foed.", id: 173 },
      { name: "S. Sandwich Ins", id: 174 },
      { name: "S.TomePrincipe", id: 175 },
      { name: "Salomonen", id: 176 },
      { name: "Sambia", id: 177 },
      { name: "Samoa Amerikan", id: 178 },
      { name: "San Marino", id: 179 },
      { name: "Saudi-Arabien", id: 180 },
      { name: "Schweden", id: 181 },
      { name: "Senegal", id: 182 },
      { name: "Serbien/Monten.", id: 183 },
      { name: "Seychellen", id: 184 },
      { name: "Sierra Leone", id: 185 },
      { name: "Simbabwe", id: 186 },
      { name: "Singapur", id: 187 },
      { name: "Sint Maarten", id: 188 },
      { name: "Slowakei", id: 189 },
      { name: "Slowenien", id: 190 },
      { name: "Somalia", id: 191 },
      { name: "Spanien", id: 192 },
      { name: "St. Helena", id: 193 },
      { name: "St. Lucia", id: 194 },
      { name: "St. Vincent", id: 195 },
      { name: "St.Kitts&Nevis", id: 196 },
      { name: "St.Pier.Miquel.", id: 197 },
      { name: "Sudan", id: 198 },
      { name: "Suriname", id: 199 },
      { name: "Svalbard", id: 200 },
      { name: "Swasiland", id: 201 },
      { name: "Syrien", id: 202 },
      { name: "Südafrika", id: 203 },
      { name: "Südkorea", id: 204 },
      { name: "Südsudan", id: 205 },
      { name: "Tadschikistan", id: 206 },
      { name: "Taiwan", id: 207 },
      { name: "Tansania", id: 208 },
      { name: "Thailand", id: 209 },
      { name: "Togo", id: 210 },
      { name: "Tokelau-Inseln", id: 211 },
      { name: "Tonga", id: 212 },
      { name: "TrinidadTobago", id: 213 },
      { name: "Tschad", id: 214 },
      { name: "Tschechische Re", id: 215 },
      { name: "Tunesien", id: 216 },
      { name: "Turkmenistan", id: 217 },
      { name: "Turks-Caicosin", id: 218 },
      { name: "Tuvalu", id: 219 },
      { name: "Türkei", id: 220 },
      { name: "Uganda", id: 221 },
      { name: "Ukraine", id: 222 },
      { name: "Ungarn", id: 223 },
      { name: "Uruguay", id: 224 },
      { name: "USA", id: 225 },
      { name: "Usbekistan", id: 226 },
      { name: "Vanuatu", id: 227 },
      { name: "Vatikanstadt", id: 228 },
      { name: "Venezuela", id: 229 },
      { name: "Ver.Arab.Emir.", id: 230 },
      { name: "Verein.Königr.", id: 231 },
      { name: "Vietnam", id: 232 },
      { name: "WallisFutuna", id: 233 },
      { name: "Weichnachtsinsel", id: 234 },
      { name: "West Sahara", id: 235 },
      { name: "Westsamoa", id: 236 },
      { name: "Zentralaf. Rep.", id: 237 },
      { name: "Zypern", id: 238 },
      { name: "Ägypten", id: 239 },
      { name: "Äquatorinalguine", id: 240 },
      { name: "Äthopien", id: 241 },
    ],
  }

  return (
    <MDefaultform
      buttonLabel="Anfrage absenden"
      postUrl={process.env.FORM_API_URL}
      disableCaptcha={data.form_definition[0].captcha === 0}
      identifier={data.form_recipient[0].identifier}
      formType={formType}
    >
      {({ register, errors }) => (
        <>
          {data.headline && (
            <DfbHeadline
              headline={data.headline}
              headline_level="h3"
              add_class="m-Formblock-headline"
            />
          )}
          {data.text && (
            <DfbParagraph add_class="m-Formblock-text" text={data.text} />
          )}
          <DfbHeadline
            headline={t("form.personalInformation")}
            headline_level="h4"
            add_class="m-Formblock-headline"
          />
          {fields.country && (
            <div className="m-Formblock-row-third">
              {selectCountry.values.length >= 2 && (
                <div className="m-Formblock-row-third-cell">
                  <DfbSelect
                    {...register("country", {
                      required: t("form.errorMessages.select"),
                    })}
                    label={checkRequireLabel(fields.country)}
                    options={selectCountry.values}
                    placeholder={t("form.placeholder.select")}
                    errorMessage={errors?.category?.message}
                    error={errors["country"]}
                  />
                </div>
              )}
              <div className="m-Formblock-row-third-cell"></div>
              <div className="m-Formblock-row-third-cell"></div>
            </div>
          )}
          {(fields.categoryofmedia || fields.memberof || fields.function) && (
            <div className="m-Formblock-row-third">
              <div className="m-Formblock-row-third-cell">
                {selectMedia.values && (
                  <DfbSelect
                    {...register(fields.categoryofmedia.identifier, {
                      required: t("form.errorMessages.select"),
                    })}
                    label={checkRequireLabel(fields.categoryofmedia)}
                    options={selectMedia.values}
                    placeholder={t("form.placeholder.select")}
                    errorMessage={errors?.categoryofmedia?.message}
                    error={errors[fields.categoryofmedia.identifier]}
                  />
                )}
              </div>
              <div className="m-Formblock-row-third-cell">
                {selectFunction.values && (
                  <DfbSelect
                    {...register(fields.function.identifier, {
                      required: t("form.errorMessages.select"),
                    })}
                    label={checkRequireLabel(fields.function)}
                    options={selectFunction.values}
                    placeholder={t("form.placeholder.select")}
                    errorMessage={errors?.function?.message}
                    error={errors[fields.function.identifier]}
                  />
                )}
              </div>
              <div className="m-Formblock-row-third-cell">
                {selectMemberof.values && (
                  <DfbSelect
                    {...register(fields.memberof.identifier, {
                      required: t("form.errorMessages.select"),
                    })}
                    label={checkRequireLabel(fields.memberof)}
                    options={
                      selectMemberof.values.length >= 2
                        ? selectMemberof.values
                        : selectMemberof.values[0]
                    }
                    placeholder={t("form.placeholder.select")}
                    errorMessage={errors?.memberof?.message}
                    error={errors[fields.memberof.identifier]}
                  />
                )}
              </div>
            </div>
          )}
          {fields.orother && (
            <div className="m-Formblock-input">
              <DfbInputTextarea
                {...register(fields.orother.identifier, {
                  required: t("form.errororother.input"),
                })}
                label={checkRequireLabel(fields.orother)}
                error={errors[fields.orother.identifier]}
                errororother={errors?.orother?.message}
              />
            </div>
          )}
          {fields.presscardnumber && (
            <div className="m-Formblock-input">
              <DfbInput
                {...register(fields.presscardnumber.identifier, {
                  required: fields.presscardnumber.required
                    ? t("form.errorMessage.input")
                    : false,
                })}
                error={errors[fields.presscardnumber.identifier]}
                errorMessage={
                  errors?.[fields.presscardnumber.identifier]?.message
                }
                label={checkRequireLabel(fields.presscardnumber)}
                focused
              />
            </div>
          )}
          {fields.freelance && (
            <div className="m-Formblock-checkbox">
              <DfbCheckbox
                text={fields.freelance.label}
                {...register(fields.freelance.identifier, {
                  required: fields.freelance.required === 1,
                })}
                error={errors[fields.freelance.identifier]}
              />
            </div>
          )}
          {fields.employed && (
            <div className="m-Formblock-checkbox">
              <DfbCheckbox
                text={fields.employed.label}
                {...register(fields.employed.identifier, {
                  required: fields.employed.required === 1,
                })}
                error={errors[fields.employed.identifier]}
              />
            </div>
          )}
          <div className="m-Formblock-spacer" />
          {data.headline && (
            <DfbHeadline
              headline={t("form.businessAddress")}
              headline_level="h4"
              add_class="m-Formblock-headline"
            />
          )}
          {fields.serviceaddresscompanyname && (
            <div className="m-Formblock-input">
              <DfbInput
                {...register(fields.serviceaddresscompanyname.identifier, {
                  required: fields.serviceaddresscompanyname.required
                    ? t("form.errorMessage.input")
                    : false,
                })}
                error={errors[fields.serviceaddresscompanyname.identifier]}
                errorMessage={
                  errors?.[fields.serviceaddresscompanyname.identifier]?.message
                }
                label={checkRequireLabel(fields.serviceaddresscompanyname)}
                focused
              />
            </div>
          )}
          {(fields.serviceaddressaddress ||
            fields.serviceaddressstreetnumber) && (
            <div className="m-Formblock-input-half">
              {[fields.serviceaddressaddress, fields.serviceaddressstreetnumber]
                .filter(Boolean)
                .map((formItem, index) => (
                  <div className="m-Formblock-input" key={index}>
                    <DfbInput
                      {...register(formItem.identifier, {
                        required: formItem.required
                          ? t("form.errorMessage.input")
                          : false,
                      })}
                      error={errors[formItem.identifier]}
                      errorMessage={errors?.[formItem.identifier]?.message}
                      label={checkRequireLabel(formItem)}
                      focused
                    />
                  </div>
                ))}
            </div>
          )}
          {fields.serviceaddresszipcode && (
            <div className="m-Formblock-input">
              <DfbInput
                {...register(fields.serviceaddresszipcode.identifier, {
                  required: fields.serviceaddresszipcode.required
                    ? t("form.errorMessage.input")
                    : false,
                })}
                error={errors[fields.serviceaddresszipcode.identifier]}
                errorMessage={
                  errors?.[fields.serviceaddresszipcode.identifier]?.message
                }
                label={checkRequireLabel(fields.serviceaddresszipcode)}
                focused
              />
            </div>
          )}
          <div className="m-Formblock-input-half">
            {fields.serviceaddresscity && (
              <div className="m-Formblock-input">
                <DfbInput
                  {...register(fields.serviceaddresscity.identifier, {
                    required: fields.serviceaddresscity.required
                      ? t("form.errorMessage.input")
                      : false,
                  })}
                  error={errors[fields.serviceaddresscity.identifier]}
                  errorMessage={
                    errors?.[fields.serviceaddresscity.identifier]?.message
                  }
                  label={checkRequireLabel(fields.serviceaddresscity)}
                  focused
                />
              </div>
            )}
            {fields.serviceaddresscountry && (
              <div className="m-Formblock-input">
                {selectCountry.values.length >= 2 && (
                  <DfbSelect
                    {...register("serviceaddresscountry", {
                      required: t("form.errorMessages.select"),
                    })}
                    label={checkRequireLabel(fields.serviceaddresscountry)}
                    options={selectCountry.values}
                    placeholder={t("form.placeholder.select")}
                    errorMessage={errors?.category?.message}
                    error={errors["servicecountry"]}
                  />
                )}
              </div>
            )}
          </div>
          <div className="m-Formblock-spacer" />
        </>
      )}
    </MDefaultform>
  )
}

export default MPressApplication
